import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

import { useAlertVisuals } from "../context/AlertVisualContext";
import { getAlertAccent } from "./alerts/alertVisualPreferences";

const AlertBanner = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { activeAlerts, settings } = useAlertVisuals();
  const alert = Object.values(activeAlerts).filter(event => event.alert.status === "nueva" || !event.alert.status)
    .sort((a, b) => b.receivedAt - a.receivedAt)[0]?.alert;

  if (!settings.enabled || settings.intensity === "low" || !alert) return null;

  const label = alert.alert_type || alert.detection_type || t("platform.common.alert");
  const cam = alert.camera_name || "";
  const accent = getAlertAccent(alert.detection_type || alert.alert_type, theme.palette.mode, settings);

  return (
    <Box
      className="critical-alert-banner"
      role="alert"
      sx={{
        bgcolor: alpha(accent, theme.palette.mode === "dark" ? 0.15 : 0.08),
        color: "text.primary",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: 1.5,
        flex: "1 1 auto",
        minWidth: 0,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        border: "1px solid",
        borderColor: accent,
      }}
    >
      <Box sx={{ display: "grid", placeItems: "center", width: 32, height: 32, borderRadius: 1, border: `1px solid ${accent}`, bgcolor: alpha(accent, 0.12) }}><WarningAmberIcon sx={{ fontSize: 20, color: accent }} /></Box>
      <Typography fontWeight={600} fontSize={14} sx={{ overflowWrap: "anywhere", flex: 1 }}>
        {`${t("platform.banner.detection")}: ${label.toUpperCase()}${cam ? ` · ${cam}` : ""}`}
      </Typography>
    </Box>
  );
};

export default AlertBanner;
